// Datas de reserva trafegam como 'YYYY-MM-DD' (data civil, sem fuso).
// Os helpers abaixo extraem os componentes da string e operam em
// horário local — nunca convertem 'YYYY-MM-DD' via new Date() nem
// toISOString(), que deslocariam o dia conforme o fuso.

// Componentes {y, m, d} do valor de data civil.
// Strings 'YYYY-MM-DD' são lidas verbatim; Date usa componentes locais
// (é assim que drivers/calendários representam o dia escolhido).
const toDateParts = (dateValue) => {
  if (!dateValue) return null;
  if (dateValue instanceof Date) {
    if (isNaN(dateValue.getTime())) return null;
    return { y: dateValue.getFullYear(), m: dateValue.getMonth() + 1, d: dateValue.getDate() };
  }
  const [y, m, d] = String(dateValue).split('T')[0].split('-').map(Number);
  if (!y || !m || !d) return null;
  return { y, m, d };
};

const toLocalDate = (dateValue) => {
  const parts = toDateParts(dateValue);
  if (!parts) return null;
  return new Date(parts.y, parts.m - 1, parts.d);
};

export function nightsBetween(startValue, endValue) {
  const start = toLocalDate(startValue);
  const end = toLocalDate(endValue);
  if (!start || !end) return 0;
  return Math.max(0, Math.round((end - start) / (1000 * 60 * 60 * 24)));
}

// Formata 'YYYY-MM-DD' para exibição local (dd/mm/aaaa) sem deslocar o dia.
export function formatDateSafe(dateValue) {
  const local = toLocalDate(dateValue);
  if (!local) return '-';
  return local.toLocaleDateString('pt-BR');
}

// 'YYYY-MM-DD' do dia de hoje no fuso local (new Date().toISOString()
// devolveria o dia em UTC, que difere do dia civil perto da meia-noite).
export function todayLocalISO() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
